import { render, staticRenderFns } from "./EditDistributorClient.vue?vue&type=template&id=30d66246&"
import script from "./EditDistributorClient.vue?vue&type=script&lang=js&"
export * from "./EditDistributorClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports